import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../constants/api";
import { baseUrl } from "../constants/url";
import getHeaders from "../utils/getHeaders";

const ClubMagazine = () => {

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [page, setPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(20)
  const [data, setData] = useState([])
  const [noMoreData, setNoMoreData] = useState(false)

  async function getClubMagazineData() {
    if (page > 0 && itemsPerPage > 0) {
      try {
        setLoading(true)
        setError('')
        const response = await api(false, `/club-magazine?page=${page}&limit=${itemsPerPage}`, 'get', {}, {
          ...getHeaders()
        })
        setLoading(false)
        if (Array.isArray(response.data.data) && response.data.data.length <= 0) {
          setNoMoreData(true)
          if (page > 1) {
            setPage(page - 1)
          }
          return
        }

        if (Array.isArray(response.data.data) && response.data.data.length < itemsPerPage) {
          setNoMoreData(true)
        }
        setData(response.data.data)
      } catch (error: any) {
        console.log(error)
        setLoading(false)
        setError(error?.response?.data?.message || error.message)
        setData([])
      }
    }
  }

  const handlePrev = () => {
    if (page > 1) {
      setNoMoreData(false)
      setPage(page - 1)
    }
  }

  const handleNext = () => {
    if (!noMoreData) {
      setPage(page + 1)
    }
  }

  useEffect(() => {
    getClubMagazineData()
  }, [page])

  useEffect(() => {
    // if (localStorage.getItem('lastAuthTimeMillis') &&
    // // @ts-ignore
    // parseInt(localStorage.getItem('lastAuthTimeMillis')) > (new Date().getTime()) - 30*60*1000) {
    //    // @ts-ignore
    //   axios.defaults.headers.common['MemberCode'] = localStorage.getItem('MemberCode');
    //    // @ts-ignore
    //   axios.defaults.headers.common['MemberId'] = localStorage.getItem('MemberId');
    //    // @ts-ignore
    //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('Authorization');
    // } else {
    //   window.location.href = '/';
    // }
  }, []);

  return (
    <div className="basePriceContainer">
      <h1 className="h1header basePrice">Club Magazines</h1>
      {error && (
        <p style={{ color: 'red' }}>{error}</p>
      )}
      <div className="table-responsive">
      <table className="tbl styled-table" border={1}>
        <thead>
          <tr>
            <th style={{minWidth: 200}}>
              Name
            </th>
            <th style={{minWidth: 250}}>
              URL
            </th>
          </tr>
        </thead>
        <tbody style={{height: 30}}>
          {loading && (
            <tr>
              <td colSpan={2}>
                Loading...
              </td>
            </tr>
          )}
          {!loading && (
            data.map((item: any, index: number) => (
              <tr key={index}>
                <td>
                  {item.name}
                </td>
                <td>
                  <a href={item.url}>
                    Click Here
                  </a>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
      <div className="page-buttons-container">
        <button disabled={page === 1} onClick={handlePrev} style={{width: 50, padding: 4}}>Prev</button>
        <button disabled={noMoreData} onClick={handleNext} style={{width: 50, padding: 4}}>Next</button>
      </div>
    </div>
  );
};

export default ClubMagazine;
